(function () {
  function init(section) {
    if (!section) return;

    const enable = section.getAttribute("data-enable-marquee") === "true";
    const track = section.querySelector("[data-slt-track]");
    const row = section.querySelector("[data-slt-row]");
    const clone = section.querySelector("[data-slt-row-clone]");

    if (!track || !row || !clone) return;

    // Reset
    section.dataset.marquee = "off";
    clone.innerHTML = "";

    if (!enable) return;

    // We need layout sizes after images load
    const refresh = () => {
      // Reset again
      section.dataset.marquee = "off";
      clone.innerHTML = "";

      const trackWidth = track.clientWidth;
      const rowWidth = row.scrollWidth;

      // If content fits, no marquee needed
      if (rowWidth <= trackWidth) {
        return;
      }

      // Duplicate row content for seamless infinite scroll
      clone.innerHTML = row.innerHTML;
      section.dataset.marquee = "on";
    };

    // Run now + after images load
    refresh();

    // If images are lazy-loaded, refresh on load
    const imgs = section.querySelectorAll("img");
    imgs.forEach((img) => {
      if (!img.complete) {
        img.addEventListener("load", refresh, { once: true });
        img.addEventListener("error", refresh, { once: true });
      }
    });

    // Refresh on resize
    let t;
    window.addEventListener("resize", () => {
      clearTimeout(t);
      t = setTimeout(refresh, 150);
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-slt]").forEach(init);

    // Shopify Theme Editor support (dynamic section load)
    document.addEventListener("shopify:section:load", (e) => {
      init(e.target.querySelector("[data-slt]") || e.target);
    });
  });
})();
